import React from 'react'
import { motion } from 'framer-motion'
import BGHomePage from '../../assets/images/BGHomePage.jpg'
import '../../index.css'

const style = {
  scrollSnapAlign: 'start',
  scrollSnapStop: 'always',
}

export const withChild = (Component) => {
  return function WrappedComponent(props) {
    return <Component {...props} style={{ ...props.style, ...style }} />
  }
}

// Parent Wrapper (scroll-snapping the container)
const styleParent = {
  scrollSnapType: 'y mandatory',
}

export const withParent = (Component) => {
  return function WrappedComponent(props) {
    return <Component {...props} style={{ ...props.style, ...styleParent }} />
  }
}

const SnapSection = withChild(motion.section)

const Section1 = () => {
  const fadeInUpVariant = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.9 } },
  }

  return (
    <SnapSection
      style={{ height: 'calc(100vh - 5rem)' }}
      className="Section1 mt-0  z-10 container-fluid relative bg-yellow-800 "
      initial="hidden"
      animate="visible"
      variants={fadeInUpVariant}
    >
      {/* Back``ground Image */}
      <img
        src={BGHomePage}
        alt="Background Home Page"
        className="BGHomePage absolute top-0 left-0 w-full overflow-hidden object-cover lg:object-fill h-full "
        variants={fadeInUpVariant}
      />

      {/* Responsive Content */}
      <div
        className="Section1-container bottom-0 mx-0 py-4 block w-[1010px] text-white  absolute left-1/2 h-[110px translate-x-[-50%]"
        variants={fadeInUpVariant}
        transition={{ delay: 0.4 }}
      >
        <div className="w-full">
          <h1> Your Learning Journey, Powered </h1>
          <h1 className="mt-3">by Vetted Blockchain Tutors</h1>
        </div>
      </div>
    </SnapSection>
  )
}

export default Section1
